import { GeneralLedgerRow } from '@/renderer/types/accounting';
import React from 'react';
import { formatCurrencyValue } from './accountingReports';

interface GeneralLedgerTableProps {
  rows: GeneralLedgerRow[];
}

export function GeneralLedgerTable({ rows }: GeneralLedgerTableProps) {
  return (
    <div className="max-h-[560px] overflow-auto rounded-2xl border border-gray-200">
      <table className="min-w-full divide-y divide-gray-200 text-sm">
        <thead className="sticky top-0 bg-gray-50">
          <tr className="text-left text-xs uppercase tracking-wide text-gray-500">
            <th className="px-4 py-3">Date</th>
            <th className="px-4 py-3">Account</th>
            <th className="px-4 py-3">Reference</th>
            <th className="px-4 py-3">Memo</th>
            <th className="px-4 py-3 text-right">Debit</th>
            <th className="px-4 py-3 text-right">Credit</th>
            <th className="px-4 py-3 text-right">Running balance</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100 bg-white">
          {rows.map((row) => (
            <tr key={row.journal_entry_line_id} className="align-top">
              <td className="px-4 py-3 text-gray-600">{row.entry_date}</td>
              <td className="px-4 py-3">
                <p className="font-semibold text-gray-900">
                  {row.account_code} - {row.account_name}
                </p>
                <p className="mt-1 text-xs text-gray-500 capitalize">
                  {row.account_type} · {row.source_module}
                </p>
              </td>
              <td className="px-4 py-3 text-gray-600">
                <p>{row.reference_type || 'No reference type'}</p>
                <p className="mt-1 text-xs text-gray-500">
                  {row.reference_id || 'No reference id'}
                </p>
              </td>
              <td className="px-4 py-3 text-gray-600">
                <p>{row.memo || 'No memo'}</p>
                <p className="mt-1 text-xs text-gray-500">
                  {row.line_description || 'No line description'}
                </p>
              </td>
              <td className="px-4 py-3 text-right font-medium text-gray-700">
                {formatCurrencyValue(row.debit)}
              </td>
              <td className="px-4 py-3 text-right font-medium text-gray-700">
                {formatCurrencyValue(row.credit)}
              </td>
              <td className="px-4 py-3 text-right font-semibold text-gray-900">
                {formatCurrencyValue(row.running_balance)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
